/**
=========================================================
* TripEnhancer - Article Page
=========================================================
* 
* Dynamic article page that displays article content
* and handles deep linking to the mobile app
*/

import { useParams } from "react-router-dom";

// Components
import ArticleLandingPage from "components/ArticleLandingPage";
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Article data
import { getArticleData } from "lib/articles";

function Article() {
  const { articleId } = useParams();
  const article = getArticleData(articleId);

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "https://play.google.com/store/apps/details?id=com.naxx.tripenhancer.free",
          label: "Download App",
          color: "info",
        }}
        sticky
      />
      <ArticleLandingPage article={article} />
      <DefaultFooter content={footerRoutes} />
    </>
  );
}

export default Article;
